import React, { useEffect, useState } from "react";
import { Label, RequiredRule } from 'devextreme-react/form';
import { CheckBox, DateBox, NumberBox, TextBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";
import { function_ABM_EEX_Clientes_EnvioMailCambioEMail, function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import { validarEMail } from "../../../../funciones/Varios.js";
import { ErrorSharp } from "@mui/icons-material";

const EXT_IntegranteCambioEMail = (props) => {
  const [puedeGuardar, setPuedeGuardar] = useState(false);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);
  const [idCliente, setIdCliente] = useState(0);
  const [cuit, setCUIT] = useState("");
  const [cuitAnterior, setCUITAnterior] = useState("");
  const [eMail, setEMail] = useState("");
  const [eMailAnterior, setEMailAnterior] = useState("");

  const handleOnClickEnviar = async () => {
    if (cuit != cuitAnterior) {
      alert("El D.N.I. ingresado no corresponde al usuario que desea cambiar")
      return
    }

    if (!validarEMail(eMail)) {
      alert("El E-Mail es inválido")
      return
    }

    try {
      await function_ABM_EEX_Clientes_EnvioMailCambioEMail(idCliente, cuitAnterior, eMail)
      
      alert("Se ha enviado un correo con un link el cual debe ser abierto para poder realizar el cambio de correo.")
    } catch (error) {
      alert(error)
    }
  };

  useEffect(() => {
    localStorage.setItem("CodigoCompania", props.CodigoCompania);
    localStorage.setItem("CodigoEmpresa", props.CodigoEmpresa);
    localStorage.setItem("CodigoPlanta", props.CodigoPlanta);
    setIdCliente(props.IdCliente);

    const leerCliente = async () => {
      const resultGenerador = await function_ABM_EEX_Clientes_Leer(props.IdCliente);
      if (resultGenerador?.data?.CUIT) {
        setCUITAnterior(resultGenerador.data.CUIT);
        setEMailAnterior(resultGenerador.data.Emails);
      }
    };

    leerCliente();
  }, []);

  return (

    <div className="LV-GroupBox-div" style={{
      width: '100%',
      gap: '20px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <strong style={{ fontSize: '20px' }}>Cambio de E-Mail</strong><br />
      <br />
      <br />
      Para completar el cambio de dirección de correo electrónico ( actualmente {eMailAnterior} ), te enviaremos un mensaje al nuevo e-mail que ingreses.<br />
      <br />
      Es necesario que respondas ese correo para confirmar la modificación.<br />
      <br />
      Hasta que eso ocurra, tu e-mail actual seguirá siendo el válido para todas las notificaciones.<br />
      <br />
      Si no ves el mensaje en tu bandeja de entrada, recordá revisar la carpeta de correo no deseado o spam.
      <br />
      <br />
      <br />
      <NumberBox
        label="D.N.I."
        value={cuit}
        width={120}
        onValueChanged={e => setCUIT(e.value)}>
        <Label text="D.N.I." />
        <RequiredRule message="Indicar el D.N.I. es obligatorio." />
      </NumberBox>

      <TextBox
        label="E-Mail"
        value={eMail}
        onValueChanged={e => setEMail(e.value)}
        width={400}>
        <Label text="E-Mail" />
        <RequiredRule message="Indicar el E-Mail es obligatorio." />
      </TextBox>

      <LVButtonAccion
        Disabled={cierreEnProceso} Texto="ENVIAR SOLICITUD AL NUEVO E-MAIL" Ancho={350} onClick={handleOnClickEnviar} />
    </div>
  );

}

export default EXT_IntegranteCambioEMail;